import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { ButtonSubmit, PasslyButton } from '@app/components';
import { ManageMfaSteps } from '@app/enums';
import {
    getIsDisabledManageMfa,
    handleClickPrimaryManageMfa,
    getPrimaryBtnNameManageMfa,
    decrementStepValue
} from '@app/helpers';
import { ActiveMethodManageMfa } from '@app/models';
import { setExceptionHandler } from '@app/store/actions';
import { ManageMfa } from '@app/modules/mfaToken/components';

interface IProps {
    setCompleted: () => void;
    backToWelcome: () => void;
}

export const OnboardSetMfaToken: React.SFC<IProps> = ({ setCompleted, backToWelcome }) => {
    const sourceCancel = axios.CancelToken.source();

    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    useEffect(() => {
        dispatch(setExceptionHandler(true));
    }, [dispatch]);

    const [activeMethod, setActiveMethod] = useState<ActiveMethodManageMfa>('');
    const [stepManageMfa, setStepManageMfa] = useState<ManageMfaSteps>(ManageMfaSteps.chooseMethod);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [passCode, setPassCode] = useState<string>('');
    const [isDisableButtonNext, setIsDisableButtonNext] = useState<boolean>(true);
    const [isWaitResponse, setIsWaitResponse] = useState<boolean>(false);

    const onSubmitForm = () =>
        handleClickPrimaryManageMfa({
            setIsWaitResponse,
            setStepManageMfa,
            stepManageMfa,
            passCode,
            verifyErrorCb: () => {
                setErrorMessage(translation('MFA_FAILED_VALIDATION'));
            },
            completeCb: setCompleted
        });

    const handleGoBack = () => {
        setErrorMessage('');
        setPassCode('');

        if (stepManageMfa === ManageMfaSteps.chooseMethod) {
            backToWelcome();
        } else {
            decrementStepValue(setStepManageMfa);
        }
    };

    return (
        <form
            className='onboard-manage-mfa-token__wrapper'
            onSubmit={(e) => {
                e.preventDefault();
                onSubmitForm();
            }}
        >
            <ManageMfa
                isOnboarding={true}
                isMfaConfigured={false}
                activeMethod={activeMethod}
                setActiveMethod={setActiveMethod}
                sourceCancel={sourceCancel}
                isDisableButtonNext={isDisableButtonNext}
                setIsDisableButtonNext={setIsDisableButtonNext}
                setStepManageMfa={setStepManageMfa}
                setErrorMessage={setErrorMessage}
                setPassCode={setPassCode}
                errorMessage={errorMessage}
                stepManageMfa={stepManageMfa}
                passCode={passCode}
                setCompleted={setCompleted}
            />
            <div className='onboard__buttons'>
                <ButtonSubmit
                    id='manageMfaOnboarding'
                    onClick={onSubmitForm()}
                    className='onboard__button--submit'
                    isDisabled={getIsDisabledManageMfa(stepManageMfa, activeMethod, isDisableButtonNext, passCode) || isWaitResponse}
                    isLoad={isWaitResponse}
                    buttonText={getPrimaryBtnNameManageMfa(activeMethod, stepManageMfa, translation)}
                />
                <PasslyButton id='onboardBackButton' color='primary' onClick={handleGoBack} disableRipple={true} className='onboard__button-back'>
                    {translation('BACK')}
                </PasslyButton>
            </div>
        </form>
    );
};
